"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SubHeader_1 = __importDefault(require("../../../../common/SubHeader"));
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var Evaluation_1 = __importDefault(require("./Evaluation"));
var GroupReport_1 = __importDefault(require("./GroupReport"));
var IndividualReport_1 = __importDefault(require("./IndividualReport"));
var InstallationReport_1 = __importDefault(require("./InstallationReport"));
var SynchronizationReport_1 = __importDefault(require("./SynchronizationReport"));
var WatchedVideo_1 = __importDefault(require("./WatchedVideo"));
var headerList = [
    {
        name: "General",
        menu: [
            {
                name: "app_installation",
                key: "app_installation",
            },
            {
                name: "synchronization",
                key: "synchronization",
            },
        ],
    },
    {
        name: "Disease",
        menu: [
            {
                name: "Watched Video Count",
                key: "watched video count",
            },
            {
                name: "Evaluation Questions",
                key: "Evaluation questions",
            },
        ],
    },
];
var GeneralReport = function (props) {
    var _a = (0, react_1.useState)(""), subType = _a[0], setSubType = _a[1];
    var _b = (0, react_1.useState)(headerList[0]), type = _b[0], setType = _b[1];
    var renderForm = function () {
        if (subType === "app_installation") {
            return react_1.default.createElement(InstallationReport_1.default, null);
        }
        else if (subType === "synchronization") {
            return react_1.default.createElement(SynchronizationReport_1.default, null);
        }
        else if (subType === "Watched Video Count") {
            return react_1.default.createElement(WatchedVideo_1.default, null);
        }
        else if (subType === "Evaluation Questions") {
            return react_1.default.createElement(Evaluation_1.default, null);
        }
        else if (subType === "Individual") {
            return react_1.default.createElement(IndividualReport_1.default, null);
        }
        else if (subType === "Group") {
            return react_1.default.createElement(GroupReport_1.default, null);
        }
    };
    var renderBody = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null, type.menu.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SubHeader_1.default, { path: "".concat(props.match.path), list: type.menu, onSubChangeTab: function (val) {
                    setSubType(val.name);
                } }),
            subType !== "" && renderForm()))));
        // }
    };
    return (react_1.default.createElement(HeaderBar_1.default, { list: headerList, alias: "report", hideSave: true, path: "".concat(props.match.path), title: "report", onChangeTab: function (val) {
            setType(val);
            setSubType(null);
        } }, renderBody()));
};
exports.default = GeneralReport;
